// extracted by mini-css-extract-plugin
export default {"container":"contact-footer_container__vz-y-","outerLink":"contact-footer_outerLink__91SpO","link":"contact-footer_link__Cv+eN"};